// @flow
import { createAction } from 'redux-act';

export type SetSearchAction = {
  (...mixed): {
    meta?: mixed,
    payload: mixed,
    type: string,
    ...
  },
  assignTo: mixed => void,
  assigned: () => boolean,
  bindTo: mixed => mixed,
  bound: () => boolean,
  dispatched: () => boolean,
  getType: () => string,
  raw: () => mixed,
  toString: () => string,
  ...
};

export const set: SetSearchAction = createAction('[search] Set');
export const setLoading: SetSearchAction = createAction(
  '[search] Set loading state',
);
export const setFirstResultLoading: SetSearchAction = createAction(
  '[search] Set first result loading state',
);
export const setError: SetSearchAction = createAction('[search] Set error');
export const setFilterFailed: SetSearchAction = createAction(
  '[search] Set Filter Failed',
);
export const setAlteredSearch: SetSearchAction = createAction(
  '[search] Set Altered Search',
);
export const setRequiredAvailables: SetSearchAction = createAction(
  '[search] Set Required Availables',
);
export const reset: SetSearchAction = createAction('[search] Reset');
export const setSearchUUID: SetSearchAction = createAction('[search] Reset');
